export default __webpack_public_path__ + "42b0279358fc8134a6a1107dc9069aff.svg";